"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 机构持股详情页
 */
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var webconfig = require("../../config/web.js");
var base_1 = __importDefault(require("./base"));
var alldate = {};
//let chart = echarts.init(document.getElementById("chart-container"));
init();
//事件配置
loadevent();
function loadevent() {
    if (!fieldtools_1["default"].isEmpty(fieldtools_1["default"].getUrlParam("date"))) {
        $("#box_mx").show();
        $("#box_tj").hide();
        $("#filter_mkt li").removeClass("at");
        $("#filter_mkt li[data-value='mx']").addClass("at");
    }
    $("#filter_mkt li").on('click', function () {
        $("#filter_mkt li").removeClass("at");
        $(this).addClass("at");
        if ($(this).data("value") == "mx") {
            $("#box_mx").show();
            $("#box_tj").hide();
            var ss = $("#filter_date").val().toString();
            alldate[ss] && base_1["default"].settip(alldate[ss]);
        }
        else {
            $("#box_mx").hide();
            $("#box_tj").show();
            base_1["default"].settip(alldate.last);
        }
    });
    $("#filter_date_li").on('click', 'li', function () {
        $("#filter_date_li li").removeClass("at");
        $(this).addClass("at");
        $("#filter_date").val(fieldtools_1["default"].dateformat($(this).data("value"))).trigger('change');
    });
}
// 数据日期获取
function init() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            $.ajax({
                url: webconfig.getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: 'RPT_NATIONAL_REPORTDATE',
                    columns: 'ALL',
                    source: "WEB",
                    client: "WEB",
                    sortColumns: "REPORT_DATE",
                    sortTypes: -1
                }
            }).then(function (json) {
                var _a;
                var list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
                if (list === null || list === void 0 ? void 0 : list[0]) {
                    base_1["default"].settip(list === null || list === void 0 ? void 0 : list[0]);
                    alldate.last = list[0];
                }
                list.map(function (item) {
                    var date = fieldtools_1["default"].dateformat(item.REPORT_DATE);
                    alldate[date] = item;
                });
                //表配置
                loadtabledata_tj();
            });
            return [2 /*return*/];
        });
    });
}
function loadtabledata_tj() {
    var opt = {
        dataurl: {
            hostname: "datacenter",
            url: "api/data/v1/get",
            params: {
                reportName: "RPT_NATIONAL_ORGHOLD_STATISTICS",
                columns: "ALL",
                quoteColumns: "",
                source: "WEB",
                client: "WEB",
                filter: "(HOLDER_CODE=\"" + ccode + "\")"
            }
        },
        sortname: "REPORT_DATE",
        urlkeyvalues: base_1["default"].urlkeyvalues,
        totalpagesfield: 'result.pages',
        datafield: 'result.data',
        columns: base_1["default"].columns,
        onPreBody: function (data) {
            var _a;
            $('#cTit').html((_a = data[0]) === null || _a === void 0 ? void 0 : _a.HOLDER_NAME);
            loaddates(data);
            loadtabledata_mx();
            //loadchart(data)
        }
    };
    $("#dataview_tj").emdataview(opt);
}
function loadtabledata_mx() {
    var opt = {
        dataurl: {
            hostname: "datacenter",
            url: "api/data/v1/get",
            params: {
                reportName: "RPT_STOCK_DETAILS_CHANGE",
                columns: "ALL",
                quoteColumns: "",
                source: "WEB",
                client: "WEB",
                filter: "(HOLDER_CODE=\"" + ccode + "\")"
            }
        },
        sortname: "SECURITY_CODE",
        urlkeyvalues: base_1["default"].urlkeyvalues,
        totalpagesfield: 'result.pages',
        datafield: 'result.data',
        columns: base_1["default"].columns,
        filteroptions: [
            {
                name: "filter",
                fieldname: "date",
                filterselector: "#filter_date",
                filtersoptionselector: "option",
                values: function (value) {
                    return "(REPORT_DATE='" + value + "')";
                },
                handle: function (filter, that) {
                    $("#filter_date_li .temp").remove();
                    $("#filter_date_li li").removeClass('at');
                    var atli = $("#filter_date_li li[data-value='" + filter.value + "']");
                    if (atli.length) {
                        atli.addClass('at');
                    }
                    else {
                        $("#filter_date_li").append("<li class=\"at temp\" data-value=\"" + filter.value + "\"><span>" + filter.value + "</span><i></i></li>");
                    }
                    alldate[filter.value] && base_1["default"].settip(alldate[filter.value]);
                }
            }
        ]
    };
    $("#dataview_mx").emdataview(opt);
}
var f = true;
function loadchart(datas) {
    if (!f)
        return;
    var chart = echarts.init(document.getElementById("chart-container"));
    var xdata = [];
    var zsdata = [];
    var ydata = [];
    datas.forEach(function (item, index) {
        xdata.unshift(fieldtools_1["default"].dateformat(item.REPORT_DATE, "YYYY/MM/DD"));
        zsdata.unshift(item.HX300_CLOSE_PRICE);
        ydata.unshift(item.HOLD_MARKET_CAP);
    });
    var option = {
        color: ['#00a1ea', '#df3c1c'],
        legend: {
            bottom: 5,
            selectedMode: false
        },
        grid: {
            top: 40,
            right: 15,
            bottom: 40,
            left: 15,
            containLabel: true
        },
        tooltip: {
            confine: true,
            trigger: 'axis',
            formatter: function (data) {
                var str = "";
                var date = data[0].axisValue;
                for (var i = 0; i < data.length; i++) {
                    if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                        str += data[i].marker + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 2 }) + '<br/>';
                    }
                }
                return date + '<br/>' + str;
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLine: {
                lineStyle: {
                    color: '#d6d6d6'
                },
            },
            axisLabel: {
                textStyle: {
                    color: '#6d6d6d'
                },
                showMaxLabel: true
            },
            data: xdata
        },
        yAxis: [{
                name: "单位：元",
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#6d6d6d'
                    },
                },
                axisLabel: {
                    formatter: function (value, index) {
                        return fieldtools_1["default"].fieldfmt(value, { trim: true });
                    },
                    textStyle: {
                        color: '#6d6d6d'
                    }
                },
                axisTick: {
                    lineStyle: {
                        color: '#d6d6d6'
                    },
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: '#d6d6d6',
                        type: 'dotted'
                    },
                    show: false
                },
                scale: true
            }, {
                name: "沪深300指数",
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#6d6d6d'
                    },
                },
                axisLabel: {
                    textStyle: {
                        color: '#6d6d6d'
                    }
                },
                axisTick: {
                    lineStyle: {
                        color: '#d6d6d6'
                    },
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: '#d6d6d6',
                        type: 'dotted'
                    }
                },
                scale: true
            }],
        series: [
            {
                name: '持有市值合计',
                type: 'line',
                data: ydata,
                symbol: 'circle',
                symbolSize: 2,
                showAllSymbol: false,
                yAxisIndex: 0,
                lineStyle: { width: 1.5 }
            },
            {
                name: "沪深300指数",
                type: 'line',
                data: zsdata,
                symbol: 'circle',
                symbolSize: 2,
                showAllSymbol: false,
                yAxisIndex: 1,
                lineStyle: { width: 1.5 }
            }
        ]
    };
    chart.setOption(option);
    f = false;
}
function loaddates(datas) {
    var htmlLeft = '';
    var htmlRight = '';
    for (var i = 0; i < datas.length; i++) {
        var date = fieldtools_1["default"].dateformat(datas[i].REPORT_DATE);
        if (i <= 4) {
            htmlLeft += '<li data-value="' + date + '"><span>' + date + '</span><i></i></li>';
        }
        htmlRight += '<option value="' + date + '">' + date + '</option>';
    }
    $('#filter_date_li').html(htmlLeft);
    $('#filter_date').html(htmlRight);
}
